<div class="content-box_module__333d9 content-box_lg__3v3a-">
  <header _ngcontent-bps-c143="" class="content-box_header__xPnGx clearfix">
    <div _ngcontent-bps-c143="" class="wil-float-left">
      <h4 _ngcontent-bps-c143="" class="content-box_title__1gBHS">
        <span _ngcontent-bps-c143="">Following</span>
      </h4>
    </div>
  </header>

  <div class="content-box_body__3tSRB">
    <div class="jobsearch-typo-wrap">
      <div class="jobsearch-applied-jobs">
        <ul class="jobsearch-row">
          <li *ngFor="let following of followings; let index = index" class="jobsearch-column-12">
            <div class="jobsearch-applied-jobs-wrap">
              <a class="jobsearch-applied-jobs-thumb" [routerLink]="['/user-details/', following.employer_username]"><img
                  [src]="getUserProfilePicture(following)" alt=""></a>
              <div class="jobsearch-applied-jobs-text">
                <div class="jobsearch-applied-jobs-left">
                  <!-- <span>3 Vacancies</span> -->
                  <h2 class="jobsearch-pst-title"><a
                    [routerLink]="['/user-details/', following.employer_username]">{{following.employer_display_name}}</a></h2>
                  <ul>
                    <li><i class="fa fa-map-marker"></i> {{following.employer_address}}</li>
                    <li><i class="jobsearch-icon jobsearch-filter-tool-black-shape"></i>
                      <a [innerHTML]="following.job_sector"></a>
                    </li>
                  </ul>
                </div>
                <a (click)="unfollow(following, index)" class="jobsearch-savedjobs-links jobsearch-delete-followin-emp"
                  ><i class="jobsearch-icon jobsearch-rubbish"></i></a>
                <span class="remove-applied-job-loader"></span>
                <a [routerLink]="['/user-details/', following.employer_username]" class="jobsearch-savedjobs-links"><i
                    class="jobsearch-icon jobsearch-view"></i></a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div> <!-- jobsearch-typo-wrap -->
  </div>
</div>
